import request from 'common/Api';
import { FORMS, LOADING, MVJ_DOMAIN } from 'common/Constants';
import { getCSAUserAuthData, getPassengerNumber } from 'common/UserStore/UserSelectors';
import { base64Encode } from 'utils/strings';

const CLEAR_BOOKING_DATA = '@booking/CLEAR_BOOKING_DATA';
const RECEIVE_AZURE_DATA = '@booking/RECEIVE_AZURE_DATA';
const RECEIVE_B2C_DATA = '@user/RECEIVE_B2C_DATA';
const RECEIVE_BOOKING_DATA = '@booking/RECEIVE_BOOKING_DATA';
const SET_B2C_UPDATE_STATUS = '@user/SET_B2C_UPDATE_STATUS';
const SET_ERROR_FLAG = '@booking/SET_ERROR_FLAG';
const SET_PASSENGER_UPDATE_STATUS = '@booking/SET_PASSENGER_UPDATE_STATUS';
const UNLOCK_FLAG = '@booking/UNLOCK_FLAG';

const clearBookingData = () => ({
  type: CLEAR_BOOKING_DATA,
});

const receiveAzure = (azureData) => ({
  azureData,
  type: RECEIVE_AZURE_DATA,
});

const receiveB2CUserData = (b2cUserData) => ({
  b2cUserData,
  type: RECEIVE_B2C_DATA,
});

const receiveBooking = (bookingData) => ({
  bookingData,
  type: RECEIVE_BOOKING_DATA,
});

const setB2CUpdateStatus = (message) => ({
  message,
  type: SET_B2C_UPDATE_STATUS,
});

const setPassengerUpdateStatus = (pax, message) => ({
  message,
  pax,
  type: SET_PASSENGER_UPDATE_STATUS,
});

const signInAs =
  ({ bookingId, email, userToken }) =>
  (dispatch, getState) => {
    dispatch(setPassengerUpdateStatus(null));
    const passengerNumber = getPassengerNumber(getState());
    window.$(`#${FORMS.SIGN_IN_AS}`).modal('hide');

    window.open(
      `${MVJ_DOMAIN}?userToken=${encodeURIComponent(userToken)}&id=${bookingId}&email=${base64Encode(
        email.toLowerCase(),
      )}&pax=${passengerNumber}`,
      'MVJ',
    );
  };

const unlockBooking = (bookingNumber, passengerNumber) => (dispatch, getState) => {
  dispatch(setPassengerUpdateStatus(passengerNumber, LOADING));
  const csaUserAuthData = getCSAUserAuthData(getState());
  dispatch(
    request({
      method: 'PUT',
      url: `/booking/${bookingNumber}/superunlock/${csaUserAuthData.username}`,
    }),
  )
    .then(({ data }) => {
      if (!data?.isLocked) {
        return dispatch(setPassengerUpdateStatus(passengerNumber, 'Booking Unlocked.'));
      }
      throw new Error('unable to unlock');
    })
    .catch((e) => {
      if (e?.response?.status === 400) {
        // locked by a user in evolution. details are in e.response.data.errorDescription
        return dispatch(setPassengerUpdateStatus(passengerNumber, 'Booking is locked by Evolution.'));
      }
      // something else happened and we dont know why it failed.
      return dispatch(setPassengerUpdateStatus(passengerNumber, 'Unlock failed. Please try again.'));
    });
};

export {
  CLEAR_BOOKING_DATA,
  clearBookingData,
  RECEIVE_AZURE_DATA,
  RECEIVE_B2C_DATA,
  RECEIVE_BOOKING_DATA,
  receiveAzure,
  receiveB2CUserData,
  receiveBooking,
  SET_B2C_UPDATE_STATUS,
  SET_ERROR_FLAG,
  SET_PASSENGER_UPDATE_STATUS,
  setB2CUpdateStatus,
  setPassengerUpdateStatus,
  signInAs,
  UNLOCK_FLAG,
  unlockBooking,
};
